import { render, staticRenderFns } from "./ShipmentsChart.vue?vue&type=template&id=65bf1218&"
import script from "./ShipmentsChart.vue?vue&type=script&lang=js&"
export * from "./ShipmentsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports